import { css, SerializedStyles } from '@emotion/core';
import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ICustomTheme } from 'interfaces';

export const setColor = (
  textColor: string,
  theme: ICustomTheme,
): SerializedStyles => {
  switch (textColor) {
    case 'primary':
      return css`
        color: ${theme.colors.paletteFromBO.main};
      `;
    case 'secondary':
      return css`
        color: ${theme.colors.paletteFromBO.primary};
      `;
    case 'info':
      return css`
        color: ${theme.colors.grey.dark};
      `;
    case 'infoLight':
      return css`
        color: ${theme.colors.grey.light};
      `;
    case 'success':
      return css`
        color: ${theme.colors.success.main};
      `;
    case 'error':
      return css`
        color: ${theme.colors.error.main};
      `;
    case 'white':
      return css`
        color: ${theme.colors.white};
      `;
    case 'black':
      return css`
        color: ${theme.colors.black.main};
      `;
    default:
      return css`
        color: ${theme.colors.grey.dark};
      `;
  }
};

export const setFontCase = (fontCase: string): SerializedStyles => {
  switch (fontCase) {
    case 'upper':
      return css`
        text-transform: uppercase;
      `;
    case 'lower':
      return css`
        text-transform: lowercase;
      `;
    case 'title':
      return css`
        text-transform: capitalize;
      `;
    case 'sentence':
      return css`
        text-transform: inherit;
      `;
    default:
      return css`
        text-transform: inherit;
      `;
  }
};

export const setFontWeight = (fontWeight: string): SerializedStyles => {
  switch (fontWeight) {
    case 'light':
      return css`
        font-weight: lighter;
      `;
    case 'norm':
      return css`
        font-weight: normal;
      `;
    case 'bold':
      return css`
        font-weight: bold;
      `;
    default:
      return css`
        font-weight: normal;
      `;
  }
};

export const setTextDecoration = (textDecoration: string): SerializedStyles => {
  if (textDecoration === 'underline') {
    return css`
      text-decoration: underline;
    `;
  }
  return css`
    text-decoration: none;
  `;
};

export const StyledText = styled(Typography)<{
  fontWeight: string;
  fontCase: string;
  textColor?: string;
  textDecoration: string;
  theme: ICustomTheme;
}>`
  display: inline-block;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  color: ${({ textColor, theme }) => textColor || theme.colors.black.main};
  text-transform: ${({ fontCase }) => fontCase || 'inherit'};
  text-decoration: ${({ textDecoration }) => textDecoration || 'none'};
  font-weight: ${({ fontWeight }) => fontWeight || 'normal'};
`;
